module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7b6399d516d5921bb199f57cdd8bbbbe.svg";